import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center fw-700 mb-1"
}
const _hoisted_3 = {
  class: "btn-group btn-group-sm w-auto mb-2",
  role: "group"
}
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "mt-2 col-4" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_ColorSolidEditor = _resolveComponent("ColorSolidEditor")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['btn btn-outline-primary', { active: _ctx.colorMode === _ctx.ColorModeEnum.TOKEN }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setColorMode(_ctx.ColorModeEnum.TOKEN)))
          }, _toDisplayString(_ctx.$t('cms.colorStandard')), 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['btn btn-outline-primary', { active: _ctx.colorMode === _ctx.ColorModeEnum.RGBA }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setColorMode(_ctx.ColorModeEnum.RGBA)))
          }, _toDisplayString(_ctx.$t('cms.colorCustom')), 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['btn btn-outline-primary', { active: _ctx.colorMode === _ctx.ColorModeEnum.GRADIENT }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setColorMode(_ctx.ColorModeEnum.GRADIENT)))
          }, _toDisplayString(_ctx.$t('cms.colorGradient')), 3)
        ]),
        (_ctx.colorMode === _ctx.ColorModeEnum.TOKEN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.isBackground)
                  ? (_openBlock(), _createBlock(_component_InputSelect, {
                      key: 0,
                      modelValue: (_ctx.localDto as ColorValueRestDto).color_code,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => (((_ctx.localDto as ColorValueRestDto).color_code) = $event)),
                        _ctx.emitModelChanged
                      ],
                      options: _ctx.enumBackgroundColorCode,
                      name: _ctx.name,
                      selectText: _ctx.$t('selectText'),
                      errors: _ctx.errors,
                      canClear: true
                    }, null, 8, ["modelValue", "options", "name", "selectText", "errors", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock(_component_InputSelect, {
                      key: 1,
                      modelValue: (_ctx.localDto as TextColorValueRestDto).text_color_code,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => (((_ctx.localDto as TextColorValueRestDto).text_color_code) = $event)),
                        _ctx.emitModelChanged
                      ],
                      options: _ctx.enumTextColorCode,
                      name: _ctx.name,
                      selectText: _ctx.$t('selectText'),
                      errors: _ctx.errors,
                      canClear: true
                    }, null, 8, ["modelValue", "options", "name", "selectText", "errors", "onUpdate:modelValue"]))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.colorMode === _ctx.ColorModeEnum.RGBA && _ctx.localDto.rgba)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_ColorPicker, {
                modelValue: _ctx.localDto.rgba,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localDto.rgba) = $event)),
                  _ctx.emitModelChanged
                ],
                label: _ctx.$t('color'),
                name: _ctx.name,
                label_bold: false
              }, null, 8, ["modelValue", "label", "name", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.colorMode === _ctx.ColorModeEnum.GRADIENT && _ctx.localDto.gradient)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.localDto.gradient.direction_code,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localDto.gradient.direction_code) = $event)),
                      _ctx.emitModelChanged
                    ],
                    options: _ctx.enumGradientDirectionCode,
                    name: `${_ctx.name} ${_ctx.$t('cms.gradientDirection')}`,
                    label: _ctx.$t('cms.gradientDirection'),
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors,
                    rules: "required"
                  }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ColorSolidEditor, {
                    name: _ctx.$t('cms.gradientStart'),
                    label: _ctx.$t('cms.gradientStart'),
                    modelValue: _ctx.localDto.gradient.start,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localDto.gradient.start) = $event)),
                      _ctx.emitModelChanged
                    ],
                    isBackground: _ctx.isBackground,
                    errors: _ctx.errors
                  }, null, 8, ["name", "label", "modelValue", "isBackground", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_ColorSolidEditor, {
                    name: _ctx.$t('cms.gradientEnd'),
                    label: _ctx.$t('cms.gradientEnd'),
                    modelValue: _ctx.localDto.gradient.end,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localDto.gradient.end) = $event)),
                      _ctx.emitModelChanged
                    ],
                    isBackground: _ctx.isBackground,
                    errors: _ctx.errors
                  }, null, 8, ["name", "label", "modelValue", "isBackground", "errors", "onUpdate:modelValue"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}